import { render, staticRenderFns } from "./StepGoals.vue?vue&type=template&id=591477cc&scoped=true"
import script from "./StepGoals.vue?vue&type=script&lang=js"
export * from "./StepGoals.vue?vue&type=script&lang=js"
import style0 from "./StepGoals.vue?vue&type=style&index=0&id=591477cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591477cc",
  null
  
)

export default component.exports